/**
 * @generated SignedSource<<87c4901c98d1e54a283239a257dce7e7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HierarchyToggle$data = {
  readonly id: string;
  readonly savedViewId?: string | null | undefined;
  readonly viewId: string | null | undefined;
  readonly viewSettings?: {
    readonly canEnableGrouping: boolean | null | undefined;
    readonly canEnableHierarchy: boolean | null | undefined;
    readonly isGroupingEnabled: boolean | null | undefined;
    readonly isHierarchyEnabled: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "HierarchyToggle";
};
export type HierarchyToggle$key = {
  readonly " $data"?: HierarchyToggle$data;
  readonly " $fragmentSpreads": FragmentRefs<"HierarchyToggle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "groupBy"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "kind": "RootArgument",
      "name": "settings"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "staticViewInput"
    }
  ],
  "kind": "Fragment",
  "name": "HierarchyToggle",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "viewId"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "savedViewId"
        }
      ]
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "groupBy",
              "variableName": "groupBy"
            },
            {
              "kind": "Variable",
              "name": "issueSearchInput",
              "variableName": "issueSearchInput"
            },
            {
              "kind": "Variable",
              "name": "settings",
              "variableName": "settings"
            },
            {
              "kind": "Variable",
              "name": "staticViewInput",
              "variableName": "staticViewInput"
            }
          ],
          "concreteType": "JiraIssueSearchViewConfigSettings",
          "kind": "LinkedField",
          "name": "viewSettings",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isHierarchyEnabled"
            },
            {
              "kind": "ScalarField",
              "name": "canEnableHierarchy"
            },
            {
              "kind": "ScalarField",
              "name": "isGroupingEnabled"
            },
            {
              "kind": "ScalarField",
              "name": "canEnableGrouping"
            }
          ]
        }
      ],
      "type": "JiraSpreadsheetView",
      "abstractKey": "__isJiraSpreadsheetView"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "ed9eb9f34d09ba8c47b3995f6e15904f";

export default node;
